import React, { memo } from "react";

import { useStore } from "src/store";

import GoogleWsSearchBar from "./GoogleWsSearchBar";
import MultiProviderSearchBar from "./MultiProviderSearchBar";
import SearchPortalSearchBar from "./SearchPortalSearchBar";

import styles from "./style.css";

const SearchBar = memo(props => {
  const { searchTypeSplitRules, marginBottom, searchBarSideButtonEnabled, searchProvider, searchProviderOverride, ...rest } = props;
  const store = useStore("config");
  const { clientPortalType } = store("config");
  const { isSearchBarSideBtnRendered } = store("searchBarConfig");
  const provider = searchProviderOverride || searchProvider;
  const applyBtn = !isSearchBarSideBtnRendered && searchBarSideButtonEnabled && provider !== "googlecse";
  
  if (clientPortalType === "search_portal") {
    return <SearchPortalSearchBar {...props} />;
  }
 
  return (
    <div class={styles.container} style={{ marginBottom }}>
      <div style={{ flex: 1 }}>
        {searchTypeSplitRules === "googleSearch" ? <GoogleWsSearchBar {...rest} /> : <MultiProviderSearchBar applyBtn={applyBtn} {...rest} />}
      </div>
    </div>
  );
});

export default SearchBar;
